import { useState } from 'react';

const useRequestStatus = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const reset = () => {
    setIsLoading(false);
    setError(null);
  };

  return { isLoading, error, setIsLoading, setError, reset };
};

export { useRequestStatus };
